import Vue from 'vue'
import Vuex from 'vuex'
import router from '../src/router'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		accessToken: null,
		logginIn: false,
		loginError: null,
		useraccess: null,
		// apiurl: 'https://backleasing.azurewebsites.net/',
		// apiurl: 'http://localhost/apirestnc/',
		apiurl: 'http://52.251.38.42/nreveco/apirestncnr/',
		searchmenu: true,
		collapsemenu: false,
		filter: 'filter',
		accessRoles: [],
		accessMenu: []
	},
	mutations: {
		loginStart: (state) => {
			state.loggingIn = true
		},
		loginStop: (state, errorMessage) => {
			state.loggingIn = false
			state.loginError = errorMessage
		},
		updatefilter: (state, filtro) => {
			state.filter = filtro
		},
		updatesearchmenu: (state, estado) => {
			state.searchmenu = estado
		},
		updatecollapsemenu: (state, estado) => {
			state.collapsemenu = estado
		},
		updateuseraccess: (state, username) => {
			state.useraccess = username
		},
		updateAccessToken: (state, accessToken) => {
			state.accessToken = accessToken
		},
		updateAccessRoles: (state, accessRoles) => {
			state.accessRoles = accessRoles
		},
		updateAccessMenu: (state, accessMenu) => {
			state.accessMenu = accessMenu
		},
		logout: (state) => {
			state.accessToken = null
		}
	},
	actions: {
		doLogin ({ commit }, token) {
			commit('loginStart')
			if (token === '0') {
			  localStorage.setItem('loginError', 0)
			  commit('loginStop', 'error token')
			  commit('updateAccessToken', null)
			  return false
			} else {
			  localStorage.setItem('accessToken', token)
			  commit('updateAccessToken', token)
			}
		},
		doUsername ({ commit }, username) {
			  localStorage.setItem('useraccess', username)
			  commit('updateuseraccess', username)
			  router.push('/ResumenNegocio')
		},
		  fetchAccessToken ({ commit }) {
			commit('updateAccessToken', localStorage.getItem('accessToken'))
			commit('updateuseraccess', localStorage.getItem('useraccess'))
		  },
		  fetchAccessMenu ({ commit }) {
			commit('updateAccessRoles', JSON.parse(localStorage.getItem('accessRoles')))
			commit('updateAccessMenu', JSON.parse(localStorage.getItem('accessMenu')))
		  },
		  logout ({ commit }) {
			localStorage.removeItem('accessToken')
			commit('logout')
			router.push('/Login')
		  },
		  doSearchmenu ({ commit }, estado) {
			commit('updatesearchmenu', estado)
		  },
		  doCollapsemenu ({ commit }, estado) {
			commit('updatecollapsemenu', estado)
		  },
		  doFilter ({ commit }, filtro) {
			commit('updatefilter', filtro)
		  },
		  doMenu ({ commit }, menu) {
			localStorage.setItem('accessMenu', JSON.stringify(menu))
			commit('updateAccessMenu', menu)
		  },
		  doRoles ({ commit }, roles) {
			localStorage.setItem('accessRoles', JSON.stringify(roles))
			commit('updateAccessRoles', roles)
		  }
	},
	getters: {}
})



// WEBPACK FOOTER //
// ./src/store.js